export enum ErrorReasons {
  CommunityNotFound,
  ProductNotEnabledForCommunity,
  RouteNotFound,
  NeighborhoodNotFound
}
